

$(document).ready(function() {
    $("#nav-icon1").off("click").on("click", function () {
       $(this).toggleClass("open");
        $(".main-menu").slideToggle();
        $('body').toggleClass('overflow')
    });

    $(".accordion-wrapper .accordion-item .accordion-header").off("click").on("click", function () {
        var $currentItem = $(this).closest('.accordion-item');
        var $currentContent = $currentItem.find('.accordion-content');
        var $siblings = $currentItem.siblings('.accordion-item');

        if ($currentItem.hasClass('active')) {
            $currentItem.removeClass('active');
            $currentContent.slideUp(300);
        } else {
            $siblings.removeClass('active').find('.accordion-content').slideUp(300);

            $currentItem.addClass('active');
            $currentContent.stop(true, true).slideDown(300, function () {
            $('html, body').animate({
                scrollTop: $currentItem.offset().top - 100 
            }, 300);
            });
        }
    });

    $('.mouse-scroll').on('click', function() {
        $('html, body').animate({
            scrollTop: $('#next-sec').offset().top - 90
        }, 600);
    });


    $('.main-menu li.menu-item-has-children > a').append('<span class="menu-arrow"><i class="fa-solid fa-angle-down"></i>  </span>');
    $('.main-menu').on('click', '.menu-arrow', function(e) {
        e.preventDefault();
        e.stopPropagation();

        const $currentLi = $(this).closest('li');
        const $subMenu = $(this).closest('a').next('.sub-menu');

        if ($subMenu.is(':visible')) {
            $subMenu.slideUp();
            $(this).removeClass('active');
        } else {
           
            $currentLi.siblings().find('.sub-menu').slideUp();
            $currentLi.siblings().find('.menu-arrow').removeClass('active');

            $subMenu.slideDown();
            $(this).addClass('active');
        }
    });
});

$(window).scroll(function() {
    if ($(this).scrollTop() > 1){  
        $('.header').addClass("sticky");
    }
    else{
        $('.header').removeClass("sticky");
    }

    
    var scrollTop = $(window).scrollTop();
    if (scrollTop > 200) { 
        $('.members-login , .scrollup').addClass('show'); 
        // $('.scrollup').fadeIn(); 
    } 
    else {
        $('.members-login , .scrollup').removeClass('show'); 
        // $('.scrollup').fadeOut(); 
    }
});




